import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';



export const FC = ({
  markdownText
}: {
  markdownText: string;
}) => {
  return (
    <Markdown
      remarkPlugins={[[
        remarkGfm,
        {
          singleTilde: false
        }
      ]]}
      components={{
        li: ({ children }) => (
          <li>
            <Typography variant='formLabel'>
              {children}
            </Typography>
          </li>
        ),



        // Typography components
        p: ({ children }) => (
          <Box sx={{
            mb: 2
          }}
          >
            <Typography
              variant='formLabel'
              sx={{
                whiteSpace: 'pre-wrap'
              }}
            >
              {children}
            </Typography>
          </Box>
        ),

        h1(pr) {
          return (
            <Typography
              sx={{
                mt: 2
              }}
              variant='h3'
            >{pr.children}
            </Typography>
          );
        },

        h2(pr) {
          return (
            <Typography
              variant='h4'
              sx={{
                mb: 1
              }}
            >
              {pr.children}
            </Typography>
          );
        },

        h3(pr) {
          return (
            <Typography
              variant='h4'
              sx={{
                mb: 1
              }}
            >
              {pr.children}
            </Typography>
          );
        },



        // Table components
        table: ({ children }) => (
          <TableContainer>
            <Table>{children}</Table>
          </TableContainer>
        ),

        thead: ({ children }) => (
          <TableHead>{children}</TableHead>
        ),

        tbody: ({ children }) => (
          <TableBody>{children}</TableBody>
        ),

        tr: ({ children }) => (
          <TableRow>{children}</TableRow>
        ),

        th: ({ children, style }) => (
          <TableCell style={style}>{children}</TableCell>
        ),

        td: ({ children, style }) => (
          <TableCell style={style}>{children}</TableCell>
        )
      }}
    >
      {markdownText.trim()}
    </Markdown>
  );
};
